<template>
    <div class="labels-bar-promotion-preview">
        <div class="selected-table-row">
            <div class="selected-table-col is-1">
                {{ promo.name }}
            </div>
            <div class="selected-table-col is-2">
                {{ $store.getters.getPromoTypeByValue(promo.type) }}
            </div>
            <div class="selected-table-col is-3 text-right">
                <button
                    @click="showProducts = !showProducts"
                    type="button"
                    class="btn btn-sm btn-icon products-button--desktop"
                >
                    Produkty
                    <a-icon
                        icon="Chevron"
                        :iconConfig="{ down: !showProducts, up: showProducts }"
                    />
                </button>
            </div>
            <div class="selected-table-col is-4 text-right">
                <button
                    @click="deselectLabel(promo.id)"
                    type="button"
                    class="btn btn-sm btn-icon btn-outline"
                >
                    <a-icon icon="Close" />
                </button>
            </div>
        </div>
        <div class="collapse" id="selected-1" :class="{ show: showProducts }">
            <div
                class="tr mp-promos__product"
                v-for="(product, productId) in promo.labels"
                :key="productId"
            >
                <div class="tr__upper mp-labels__products">
                    <div class="tr__primary">
                        <div class="tr-featured">
                            <div class="c-fig c-fig--promos">
                                <img
                                    class="c-fig__img"
                                    :src="product.image.urls.small"
                                    alt
                                />
                            </div>
                            <div class="tr-featured__details">
                                <p class="typo typo--name">
                                    {{ product.name }}
                                </p>
                                <p class="typo typo--label">
                                    EAN: {{ product.ean }}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div
            class="text-gray products-button--mobile"
            style="margin-bottom: -3px"
        >
            <div class="button" @click="showProducts = !showProducts">
                Produkty
                <a-icon
                    style="width: 18px; height: 18px"
                    icon="Chevron"
                    :iconConfig="{ down: !showProducts, up: showProducts }"
                />
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'PromotionPreviewLabelsBar',
    props: {
        promo: {
            type: Object,
            required: true
        }
    },
    methods: {
        deselectLabel(promoId) {
            this.$store.dispatch('selectLabel', {
                id: promoId,
                value: false
            })
        }
    },
    data() {
        return {
            showProducts: false
        }
    }
}
</script>

<style scoped lang="scss">
@import '../../styles/_custom.scss';

@import '~bootstrap/scss/mixins';

.labels-bar-promotion-preview {
    .mp-promos__product {
        border: none;
        position: static;
        margin: 0;
        border-bottom: 1px solid var(--color-gray-300);
        border-radius: 0;
        &:last-of-type {
            border: none;
        }
    }
    .products-button {
        &--mobile {
            display: flex;
            justify-content: center;
            .button {
                display: flex;
                cursor: pointer;
            }
            @include media-breakpoint-up(md) {
                display: none;
            }
        }
        &--desktop {
            display: none;

            @include media-breakpoint-up(md) {
                display: inline-flex;
            }
        }
    }
    .tr-featured__details {
        @include media-breakpoint-up(md) {
            display: flex;
            align-items: center;
            .typo--name {
                margin-right: 1rem;
            }
        }
    }
}
</style>
